<template>
    <div class="page">
        <div class="page__content">
            <h1 class="text_13 page__title" v-if="error.statusCode === 404">404</h1>
            <h1 class="text_13 page__title" v-else>{{ $t("error") }}</h1>
            <div class="container">
                <div class="error">
                    <div class="error__title text_13">
                        <h1 v-if="error.statusCode === 404" class="text_13">{{ $t("not_found") }}</h1>
                        <h1 v-else>{{ $t("error_occur") }}</h1>
                    </div>
                    <nuxt-link v-if="$route.path !== '/'" to="/" class="button text_13">{{
                        $t("back_home")
                    }}</nuxt-link>
                    <a v-else href="/" class="button text_13">{{ $t("back_home") }}</a>
                </div>
            </div>
            <LastViewed></LastViewed>
            <!-- last viewwed -->
            <!--            <EnRecom v-if="$i18n.locale === 'ru'"></EnRecom>-->
        </div>
    </div>
</template>
<script>
import LastViewed from "@/components/LastViewed";
export default {
    name: "Error",
    props: ["error"],
    components: {
        LastViewed,
    },
    head() {
        return {
            title: this.error.statusCode === 404 ? "404" : this.$i18n.t("error_page"),
            bodyAttrs: {
                class: this.bodyClass,
            },
        };
    },
    data() {
        return {
            loaded: false,
            isMac: false,
            crumbs: [
                {
                    name: this.error.statusCode === 404 ? "404" : this.$i18n.t("error_page"),
                },
            ],
        };
    },
    computed: {
        bodyClass() {
            let bodyClass = this.$device.isDesktop ? "is_desktop" : "is_mobile";
            bodyClass += this.isMac ? " is_apple" : "";
            bodyClass += " page-" + this.$route.name;

            return bodyClass;
        },
    },
    watch: {
        $device() {
            if (this.$device.isIos || this.$device.isMacOS) this.isMac = true;
        },
    },
    mounted() {
        this.isMac = this.$device.isIos || this.$device.isMacOS;

        if (this.$device.isDesktop) {
            document.querySelector("body").style.setProperty("--footer-height", 0 + "px");
        }
    },
};
</script>
<style lang="less" scoped>
.container {
    display: flex;
    flex-direction: column;
}
.error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;
    padding: 64px 0;
    &__title {
        margin-bottom: 24px;
        text-align: center;
    }
    .button {
        padding: 11px 24px;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 100%;
        a {
            margin-left: 8px;
        }
    }
}
</style>
